import * as React from "react";

export type CaptureEmployeeReportPdfFn = () => Promise<void>;

export interface EmployeeReportPdfContextValue {
    registerCapture: (fn: CaptureEmployeeReportPdfFn | null) => void;
}

export const EmployeeReportPdfContext = React.createContext<EmployeeReportPdfContextValue>({
    registerCapture: () => {}
});
